<template>
  <div class="container-fluid h-100 centercard pt-4">
    <div class="row justify-content-center align-items-center h-100">
      <div class="col col-sm-10 col-md-10 col-lg-9 col-xl-6">
        <b-card header-tag="header" footer-tag="footer">
          <h4 slot="header" class="mb-0 text-center title">Consulta Web</h4>
          <div class="text-center">
            <img src="images/logofo2.png" alt="Logo">
          </div>
          <br>
          <template v-if="documentosDescargados">
            <b-row>
              <b-col cols="1"></b-col>
              <b-col cols="10">
                <b-row class="separador">
                  <b-col sm>
                    <b-form-group label="Tipo de Comprobante">
                      <b-form-select v-model="tipoComprobante" :options="tiposComprobante" value-field="tipo" text-field="descripcion"></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm>
                    <b-form-group label="Serie">
                      <b-form-input
                      type="text"
                      v-model="serie"
                      required
                      placeholder="XXXX"
                    />
                    </b-form-group>
                  </b-col>
                  <b-col sm>
                    <b-form-group label="Número">
                      <b-form-input
                      v-model="numero"
                      type="text"
                      required
                      placeholder="#####"
                    />
                    </b-form-group>                    
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm>
                    <b-form-group label="RUC del emisor">
                      <b-form-input
                      v-model="rucemisor"
                      type="text"
                      required
                      placeholder="###########"
                    />
                    </b-form-group>                    
                  </b-col>
                  <b-col sm>
                    <b-form-group label="RUC del receptor">
                      <b-form-input
                      v-model="rucreceptor"
                      type="text"
                      required
                      placeholder="###########"
                    />
                    </b-form-group>                    
                  </b-col>
                  <b-col sm>
                    <b-form-group label="Importe Total">
                      <b-form-input
                      v-model="importetotal"
                      type="number"
                      min="0"
                      required
                      placeholder="888.88"
                    />
                    </b-form-group>                    
                  </b-col>
                </b-row>
                <br>
                <div class="text-center">
                  <b-button
                    v-if="envioDatos"
                    type="submit"
                    @click="consultaDocumentosWeb()"
                    variant="primary"
                  >
                    <i class="fa fa-search"/> BUSCAR
                  </b-button>
                  <b-button v-else variant="secondary">
                    <i class="fa fa-pulse fa-spinner"></i> BUSCANDO...
                  </b-button>
                  <!-- <b-button type="reset" variant="danger">Cancelar</b-button> -->
                </div>
              </b-col>
              <b-col cols="1"></b-col>
            </b-row>
          </template>
          <template v-else>
            <div class="text-center">
              <template>
                <b-button
                  v-if="sendDownloadCDR"
                  type="submit"
                  @click="downloadCDR()"
                  variant="primary"
                >
                <i class="fa fa-download"/>
                 CDR</b-button>
                <b-button v-else class="btn_enviar" variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Descargando...
                </b-button>
              </template>
              <template>
                <b-button
                  v-if="sendDownloadXML"
                  type="submit"
                  @click="downloadXML()"
                  variant="primary"
                >
                <i class="fa fa-download"/>
                 XML</b-button>
                <b-button v-else class="btn_enviar" variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Descargando...
                </b-button>
              </template>
              <template>
                <b-button
                  v-if="sendDownloadPDF"
                  type="submit"
                  @click="downloadPDF()"
                  variant="primary"
                >
                <i class="fa fa-download"/>
                 PDF</b-button>
                <b-button v-else class="btn_enviar" variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Descargando...
                </b-button>
              </template>
              <b-button type="reset" @click="backView" variant="danger">
                <i class="fa fa-eject"/>
                 Cancelar</b-button>
            </div>
          </template>
          <br>
          <template slot="footer" ><div class="copyright float-right">Desarrollado por: <img src="images/data_logo.png" alt="Logo Telemovil Data" height="30px"></div></template>
          <template v-if="!documentosDescargados">
            <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
          </template>
        </b-card>
        <vue-snotify></vue-snotify>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import download from "downloadjs";
export default {
  name: "consultaWeb",
  data: () => {
    return {
      xml: "",
      pdfobject: "",
      sendDownloadCDR: true,
      sendDownloadXML: true,
      sendDownloadPDF: true,
      documentosDescargados: true,
      envioDatos: true,
      serie: "",
      numero: "",
      rucemisor: "",
      rucreceptor: "",
      importetotal: "",
      descargables: [],
      tipodoc: "1",
      tipoComprobante: "1",
      tiposComprobante: [
        {
          tipo: "1",
          descripcion: "Factura Electronica"
        },
        {
          tipo: "2",
          descripcion: "Boleta Electronica"
        },
        {
          tipo: "3",
          descripcion: "Nota de Credito Electronica"
        },
        {
          tipo: "4",
          descripcion: "Nota de Debito Electronica"
        }
      ]
    };
  },
  watch: {
    tipoComprobante: function() {
      (this.serie = ""),
        (this.numero = ""),
        (this.rucreceptor = ""),
        (this.rucemisor = ""),
        (this.importetotal = "");
    }
  },
  methods: {
    consultaDocumentosWeb: function() {
      (this.pdfobject = ""),
        (this.envioDatos = false),
        (this.tipodoc = this.tipoComprobante),
        axios
          .post(
            process.env.VUE_APP_API_URL + "clientes/consulta/" + this.tipodoc,
            {
              serie: this.serie,
              numero: this.numero,
              rucreceptor: this.rucreceptor,
              rucemisor: this.rucemisor,
              totalventa: this.importetotal
            }
          )
          .then(
            response => (
              (this.descargables = response.data),
              (this.pdfobject = response.data.base64),
              (this.xml = response.data.xml),
              (this.cdr = response.data.cdr.xml),
              (this.envioDatos = true),
              (this.documentosDescargados = false)
            )
          )
          .catch(
            error => (
              (this.envioDatos = true),
              (this.documentosDescargados = true),
              this.$snotify.error(
                "El documento que esta buscando no fue encontrado",
                "Error"
              ),
              console.log(error.response)
            )
          );
    },
    downloadCDR: function() {
      let name =
        "CDR-" +
        this.descargables.cdr.serie +
        "-" +
        this.descargables.cdr.numero +
        ".zip";
      let file = "data:application/pdf;base64," + this.cdr;
      (this.cargandocdr = false), download(file, name, "application/zip");
    },
    downloadXML: function() {
      let name =
        this.descargables.cdr.serie +
        "-" +
        this.descargables.cdr.numero +
        ".zip";
      let file = "data:application/zip;base64," + this.xml;
      download(file, name, "application/zip");
    },
    downloadPDF: function() {
      let name =
        this.descargables.cdr.serie +
        "-" +
        this.descargables.cdr.numero +
        ".pdf";
      let file = "data:application/zip;base64," + this.pdfobject;
      download(file, name, "application/pdf");
    },
    backView: function() {
      this.documentosDescargados = true;
    }
  }
};
</script>
<style>
body {
  background-color: #f4f3ef;
  font-family: 'Muli', sans-serif;
}
.input-placedark::placeholder {
  color: #353333;
  opacity: 0.6;
}
.btn_enviar {
  padding: 4px !important;
}
.centercard {
  padding-top: 5%;
}
</style>